module.exports = __webpack_public_path__ + "img/Stop_War_HD 2_00088.8bd23f99.png";